import { http } from './http';

export async function listDdActivities(params = {}) {
  const { data } = await http.get('book/volunteer-events/', { params });
  return data;
}

export async function getDdActivity(id) {
  const { data } = await http.get(`book/volunteer-events/${id}/`);
  return data;
}

export async function createDdActivity(payload) {
  const { data } = await http.post('book/volunteer-events/', payload);
  return data;
}

export async function updateDdActivity(id, payload) {
  const { data } = await http.patch(`book/volunteer-events/${id}/`, payload);
  return data;
}

export async function deleteDdActivity(id) {
  const { data } = await http.delete(`book/volunteer-events/${id}/`);
  return data;
}

